/*!
 * ST 2026-10-12 (Wrike 4579324117) — PDP does not open on Refurbished
 * -----------------------------------------------------------------------------
 * PROBLEM: Without ?variant= Shopify opens a product page on the first available variant by position.
 * If a sold-out Neu variant sits first and a Refurbished one comes next (VP250 DE, 06.–08.10.2026),
 * customers land on Refurbished without choosing it. Liquid cannot change that server-side.
 *
 * FIX (additive, no theme.js edit): sections/main-product.liquid sets data-st-open-variant on
 * <product-info> only when there is no ?variant= AND the server-selected variant is not NEW AND a NEW
 * variant is available (id = cheapest available NEW variant, snippets/st-cheapest-new-variant-id.liquid).
 * We check that variant's option values in the picker and fire ONE native 'change', i.e. exactly what a
 * customer click does: VariantPicker -> ProductInfo.renderProductInfo (section fetch) updates price,
 * buy button, sticky bar, badges and URL. No variant matching logic is duplicated.
 * If an option value is not in the picker (hidden sold-out value), we reload on ?variant=<id> instead.
 *
 * SCOPE: main PDP only (product-info without data-original-section-id, quick view skipped). Every other
 * load returns early: 0 effect, 0 fetch. Fully try/catch: must never break the PDP.
 * Same timing as assets/st-variant-deeplink-fix.js (after theme.js, defer + rAF).
 *
 * ROLLBACK: delete this asset + the data-st-open-variant attribute and the <script> line in
 *           sections/main-product.liquid ("ST 2026-10-12 … Wrike 4579324117").
 */
(function () {
  'use strict';

  function openNewVariant() {
    if (new URLSearchParams(window.location.search).has('variant')) return;

    var info = document.querySelector('product-info[data-st-open-variant]:not([data-original-section-id])');
    if (!info) return;

    try {
      var targetId = info.getAttribute('data-st-open-variant');
      var picker = info.querySelector('variant-picker');
      var dataEl = picker && picker.querySelector('[data-variants]');
      if (!dataEl) return;

      var target = JSON.parse(dataEl.textContent || '[]').find(function (v) {
        return String(v.id) === String(targetId);
      });
      if (!target || !target.available) return;

      var changed = null;
      var missing = false;
      picker.querySelectorAll('select, fieldset').forEach(function (container, i) {
        var value = target['option' + (i + 1)];
        if (value == null) return;

        if (container.tagName === 'SELECT') {
          var option = Array.prototype.find.call(container.options, function (o) { return o.value === value; });
          if (!option) { missing = true; return; }
          if (container.value === value) return;
          Array.prototype.forEach.call(container.options, function (o) { o.removeAttribute('selected'); });
          option.setAttribute('selected', '');
          container.value = value;
          changed = container;
          return;
        }

        var input = Array.prototype.find.call(container.querySelectorAll('input'), function (el) { return el.value === value; });
        if (!input) { missing = true; return; }
        if (input.checked) return;
        input.checked = true;
        changed = input;
      });

      if (missing) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', targetId);
        window.location.replace(url.toString());
        return;
      }

      // bubbles:true so the listener on <variant-picker> receives it.
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {
      /* defensive: must never block the PDP */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      requestAnimationFrame(openNewVariant);
    }, { once: true });
  } else {
    requestAnimationFrame(openNewVariant);
  }
})();
